export const LOAD_REPO = "app/LOAD_REPO";
export const LOAD_REPO_ERROR = "app/LOAD_REPO_ERROR";
export const SET_USER_DATA = "app/SET_USER_DATA";
export const SET_SOURCE_INFO = "app/SET_SOURCE_INFO";

export const GET_MODULE_CODE = "app/GET_MODULE_CODE";
export const GET_MODULE_CODE_SUCCESS = "app/GET_MODULE_CODE_SUCCESS";
export const GET_MODULE_CODE_ERROR = "app/GET_MODULE_CODE_ERROR";

export const SET_CURRENT_DROPDOWN_STATUS = "app/SET_CURRENT_DROPDOWN_STATUS";
export const CHANGE_CURRENT_DROPDOWN_STATUS =
  "app/CHANGE_CURRENT_DROPDOWN_STATUS";
export const RESET_IS_CHANGE_DROPDOWN = "app/RESET_IS_CHANGE_DROPDOWN";

export const FETCH_INITIAL_DATA = "app/FETCH_INITIAL_DATA";
export const FETCH_INITIAL_DATA_SUCCESS = "app/FETCH_INITIAL_DATA_SUCCESS";

export const SET_DIALOG_OPEN = "app/SET_DIALOG_OPEN";
export const SEND_EMAIL_TO_SYSTEM_ADMIN = "app/SEND_EMAIL_TO_SYSTEM_ADMIN";

export const CHANGE_LANGUAGE = "app/CHANGE_LANGUAGE";

export const defaultLanguage = "en";

export const SET_DIALOG_STATUS = "app/SET_DIALOG_STATUS";

export const FETCH_DATA_CAR_COMPANIES = "app/FETCH_DATA_CAR_COMPANIES";
export const FETCH_DATA_CAR_COMPANIES_SUCCESS =
  "app/FETCH_DATA_CAR_COMPANIES_SUCCESS";
export const FETCH_TARGET_LABELS = "app/FETCH_TARGET_LABELS";
export const FETCH_TARGET_LABELS_SUCCESS = "app/FETCH_TARGET_LABELS_SUCCESS";
export const AUTO_LABELS_REQUEST = "app/AUTO_LABELS_REQUEST";
export const AUTO_LABELS_SUCCESS = "app/AUTO_LABELS_SUCCESS";
export const AUTO_LABELS_FAILURE = "app/AUTO_LABELS_FAILURE";

export const SET_REPORTER_TAB = "app/SET_REPORTER_TAB";

export const GET_AUDIT_LOGS = "app/GET_AUDIT_LOGS";
export const GET_AUDIT_LOGS_SUCCESS = "app/GET_AUDIT_LOGS_SUCCESS";
export const GET_AUDIT_LOGS_ERROR = "app/GET_AUDIT_LOGS_ERROR";
